// WEB-469 (BC-1): Sentry (Better Stack ingest) FE config — extracted so Jest
// (CommonJS) can mock it without choking on `import.meta` (mirrors
// stripe-pk.ts / api-url.ts). Vite resolves these at build time.
//
// VITE_SENTRY_DSN is already set in the Railway frontend service env. When
// unset (e.g. local dev without the var), SENTRY_DSN is undefined and
// initSentry() (src/config/sentry.ts) is a complete no-op — never hardcode a
// DSN here.
export const SENTRY_DSN: string | undefined =
  (import.meta as unknown as { env: { VITE_SENTRY_DSN?: string } }).env
    ?.VITE_SENTRY_DSN || undefined;

// Vite's built-in MODE (development/production/test) — mirrors the backend's
// NODE_ENV tagging in instrument.ts so events are grouped by environment.
export const SENTRY_ENVIRONMENT: string =
  (import.meta as unknown as { env: { MODE?: string } }).env?.MODE ??
  'development';

// WEB-1991 — доли выборки трассировки ПУБЛИЧНОГО контура. Читаются СЫРЫМИ
// строками намеренно: разбор и проверка живут в
// `src/config/sentryPublicTracing.ts`, где их можно прогнать тестом (здесь
// `import.meta` Jest не переварит — ровно та же причина, по которой этот файл
// вообще существует).
//
// Пусто = умолчание кода: 10 % сессий, 100 % после первой ошибки. Значение вне
// 0..1 или не число НЕ роняет воронку: громкая запись в консоль и умолчание
// (тот же выбор, что у мягкой посадки FAL_IMAGE_MODEL на бэке) — наблюдаемость
// не вправе ломать страницу посетителю.
export const PUBLIC_TRACES_SAMPLE_RATE_RAW: string | undefined =
  (import.meta as unknown as { env: { VITE_PUBLIC_TRACES_SAMPLE_RATE?: string } })
    .env?.VITE_PUBLIC_TRACES_SAMPLE_RATE || undefined;

export const PUBLIC_TRACES_ON_ERROR_SAMPLE_RATE_RAW: string | undefined =
  (
    import.meta as unknown as {
      env: { VITE_PUBLIC_TRACES_ON_ERROR_SAMPLE_RATE?: string };
    }
  ).env?.VITE_PUBLIC_TRACES_ON_ERROR_SAMPLE_RATE || undefined;
